import { useState, useEffect, useRef } from "react";

export const useEnterpriseViewModel = () => {
    const [isLogoVisible, setIsLogoVisible] = useState(false);
    const logoRefDesktop = useRef(null);
    const logoRefTablet = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsLogoVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.3,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        const currentRefDesktop = logoRefDesktop.current;
        const currentRefTablet = logoRefTablet.current;

        if (currentRefDesktop) {
            observer.observe(currentRefDesktop);
        }

        if (currentRefTablet) {
            observer.observe(currentRefTablet);
        }

        return () => {
            if (currentRefDesktop) {
                observer.unobserve(currentRefDesktop);
            }
            if (currentRefTablet) {
                observer.unobserve(currentRefTablet);
            }
        };
    }, []);

    return {
        isLogoVisible,
        logoRefDesktop,
        logoRefTablet,
    };
};
